import React, { useState } from "react";
import "./LoginAndSignup.css";
import { auth, db } from "../../firebase";

import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";

import { doc, setDoc } from "firebase/firestore";

import { useNavigate } from "react-router-dom";
import { ADMIN_EMAIL } from "../../Config/admin.js";

export default function LoginAndSignup() {
  const [signIn, setSignIn] = useState(true);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // ================= SIGN UP =================
  const handleSignUp = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        formData.email,
        formData.password,
      );

      const user = userCredential.user;

      // SAVE USER IN FIRESTORE
      await setDoc(doc(db, "users", user.uid), {
        name: formData.name,
        email: formData.email,
        cart: [],
        createdAt: new Date(),
      });

      alert("Account Created Successfully");

      navigate("/");
    } catch (error) {
      alert(error.message);
    }
  };

  // ================= SIGN IN =================
  const handleSignIn = async (e) => {
    e.preventDefault();

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        formData.email,
        formData.password,
      );

      const user = userCredential.user;

      // ADMIN CHECK
      if (user.email === ADMIN_EMAIL) {
        navigate("/admin/products");
      } else {
        navigate("/");
      }
    } catch (error) {
      alert("Invalid email or password");
    }
  };

  return (
    <article className="signinandsignup">
      {signIn ? (
        <aside className="signin">
          <div className="signin-container">
            <h1>Sign in</h1>

            <form onSubmit={handleSignIn}>
              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
                required
              />

              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                required
              />

              <button type="submit">SIGN IN</button>
            </form>
          </div>

          <div className="hello-container">
            <h1>Hello, Friend!</h1>
            <p>Create your account to start shopping</p>

            <button onClick={() => setSignIn(false)}>SIGN UP</button>
          </div>
        </aside>
      ) : (
        <aside className="signup">
          <div className="welcomeBack-container">
            <h1>Welcome Back!</h1>
            <p>Login with your account</p>

            <button onClick={() => setSignIn(true)}>SIGN IN</button>
          </div>

          <div className="signup-container">
            <h1>Create Account</h1>

            <form onSubmit={handleSignUp}>
              <input
                type="text"
                name="name"
                placeholder="Name"
                onChange={handleChange}
                required
              />

              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={handleChange}
                required
              />

              <input
                type="password"
                name="password"
                placeholder="Password"
                onChange={handleChange}
                required
              />

              <button type="submit">SIGN UP</button>
            </form>
          </div>
        </aside>
      )}
    </article>
  );
}
